// SPDX-FileCopyrightText: Szilárd Hajba
// SPDX-License-Identifier: LGPL-3.0-or-later
import * as React from 'react';
import { dayjs } from '../utils/dates.js';
/** Single cell in the month grid. Clicking the date number navigates (drill
 *  down to day view); clicking the empty hit-target behind the content
 *  creates a new all-day event for that date. */
export function MonthCell({ date, inMonth, isToday, isNonWorking, column, locale, onDateChange, onCreateAt, children }) {
    const cls = [
        'c-cal-month-cell',
        inMonth ? 'in-month' : 'out-of-month',
        isToday ? 'is-today' : '',
        isNonWorking ? 'is-non-working' : ''
    ]
        .filter(Boolean)
        .join(' ');
    const dayNum = dayjs(date).date();
    // Build a full "weekday, month day, year" label so screen readers announce
    // context instead of just the number. Fall back to the ISO date if Intl
    // throws on an unknown locale tag.
    const dateLabel = React.useMemo(() => {
        try {
            return new Intl.DateTimeFormat(locale, {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }).format(dayjs(date).toDate());
        }
        catch {
            return date;
        }
    }, [date, locale]);
    return (React.createElement("div", { className: cls, style: column ? { gridColumn: column } : undefined },
        React.createElement("button", { type: "button", className: "c-cal-month-cell__hit", "aria-label": `Create event on ${dateLabel}`, onClick: () => onCreateAt?.(date, date, true) }),
        React.createElement("button", { type: "button", className: "c-cal-month-cell__num", "aria-label": dateLabel, onClick: (e) => {
                e.stopPropagation();
                onDateChange?.(date);
            } }, dayNum),
        children));
}
// vim: ts=4
